/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Delivery_Board_ClearInputs */

const en_delivery_board_clear = /** @type {(inputs: Delivery_Board_ClearInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kitchen is Clear`)
};

const es_delivery_board_clear = /** @type {(inputs: Delivery_Board_ClearInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`La cocina está despejada`)
};

const fr_delivery_board_clear = /** @type {(inputs: Delivery_Board_ClearInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`La cuisine est dégagée`)
};

const de_delivery_board_clear = /** @type {(inputs: Delivery_Board_ClearInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Küche ist frei`)
};

const id_delivery_board_clear = /** @type {(inputs: Delivery_Board_ClearInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dapur Kosong`)
};

/** @type {(inputs: Delivery_Board_ClearInputs) => LocalizedString} */
const ja_delivery_board_clear = en_delivery_board_clear;

/** @type {(inputs: Delivery_Board_ClearInputs) => LocalizedString} */
const zh_delivery_board_clear = en_delivery_board_clear;

/** @type {(inputs: Delivery_Board_ClearInputs) => LocalizedString} */
const ar_delivery_board_clear = en_delivery_board_clear;

/** @type {(inputs: Delivery_Board_ClearInputs) => LocalizedString} */
const it_delivery_board_clear = en_delivery_board_clear;

/** @type {(inputs: Delivery_Board_ClearInputs) => LocalizedString} */
const ru_delivery_board_clear = en_delivery_board_clear;

/** @type {(inputs: Delivery_Board_ClearInputs) => LocalizedString} */
const pt_delivery_board_clear = en_delivery_board_clear;

/** @type {(inputs: Delivery_Board_ClearInputs) => LocalizedString} */
const ko_delivery_board_clear = en_delivery_board_clear;

/**
* | output |
* | --- |
* | "Kitchen is Clear" |
*
* @param {Delivery_Board_ClearInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const delivery_board_clear = /** @type {((inputs?: Delivery_Board_ClearInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Delivery_Board_ClearInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_delivery_board_clear(inputs)
	if (locale === "es") return es_delivery_board_clear(inputs)
	if (locale === "fr") return fr_delivery_board_clear(inputs)
	if (locale === "de") return de_delivery_board_clear(inputs)
	if (locale === "ja") return ja_delivery_board_clear(inputs)
	if (locale === "zh") return zh_delivery_board_clear(inputs)
	if (locale === "ar") return ar_delivery_board_clear(inputs)
	if (locale === "id") return id_delivery_board_clear(inputs)
	if (locale === "it") return it_delivery_board_clear(inputs)
	if (locale === "ru") return ru_delivery_board_clear(inputs)
	if (locale === "pt") return pt_delivery_board_clear(inputs)
	return ko_delivery_board_clear(inputs)
});